<template>
    <div
        id="sidebar"
        class="sidebar"
        :style="{right: sidebarIsOpen ? 0 : undefined}"
    >
        <div class="sidebar__toolbar">
            <div class="arrow-btn-wrap">
                <span
                    class="material-icons"
                    @click="arrowBtnHandler"
                >
                    {{sidebarIsOpen ? 'keyboard_arrow_right' : 'keyboard_arrow_left'}}
                </span>
            </div>
            <div class="icons-wrap">
                <tab-button
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :tab="tab"
                    :sidebarIsOpen="sidebarIsOpen"
                    :active-tab="activeTab"
                    @open-tab="openSidebar"
                />
            </div>
        </div>
        <div
            ref="sidebarBody"
            class="sidebar__body"
            :class="{ open: sidebarIsOpen }"
        >
            <p class="caption">{{activeTab.caption}}</p>
            <div class="wrap">
                <div class="service-wrap">
                    <VersionsService v-if="showVersions" />
                    <notification-service v-if="showNotifications" />
                    <flow-entities-manager v-if="showFlowEntites" />
                    <EntitiesTab v-if="showEntities"/>
                    <features v-if="showFeatures"/>
                    <testTab v-if="showTestService" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import notificationService from './notifications/NotificationService'
import flowEntitiesManager from './flow_entities/flow_entities_manager'
import EntitiesTab from './entities/EntitiesTab'
import testTab from './test/TestTab'
import VersionsService from './versions/versions_service'
import tabButton from './TabButton'
import features from './features/FeaturesTab'

export default {
  components: {
    notificationService,
    flowEntitiesManager,
    EntitiesTab,
    testTab,
    VersionsService,
    tabButton,
    features
  },

  created () {
    this.activeTab = _.clone(this.tabs[0])
    KnowledgeBus.$on('sidebar::open', this.openSidebar)
  },

  beforeDestroy () {
    KnowledgeBus.$off('sidebar::open', this.openSidebar)
  },

  computed: {
    showVersions () {
      return this.activeTab.id === 1
    },

    showNotifications () {
      return this.activeTab.id === 2
    },

    showFlowEntites () {
      return this.activeTab.id === 3
    },

    showEntities () {
      return this.activeTab.id === 4
    },

    showFeatures () {
      return this.activeTab.id === 5
    },

    showTestService () {
      return this.activeTab.id === 6
    }
  },

  data () {
    return {
      sidebarIsOpen: false,
      showVersionsTab: true,
      activeTab: {
        id: '',
        caption: '',
        icon: ''
      },
      tabs: [
        {
          id: 1,
          caption: 'Versions',
          icon: 'watch_later'
        },
        {
          id: 2,
          caption: 'Notifications',
          icon: 'notifications'
        },
        {
          id: 3,
          caption: 'Flow Entities',
          icon: 'swap_calls'
        },
        {
          id: 4,
          caption: 'Entities',
          icon: 'entities',
          customIcon: true
        },
        {
          id: 5,
          caption: 'Features',
          icon: 'features',
          customIcon: true
        },
        {
          id: 6,
          caption: 'Test',
          icon: 'bug_report'
        }
      ]
    }
  },

  methods: {
    getSidebarBodyWidth () {
      if (this.$refs.sidebarBody) {
        return this.$refs.sidebarBody.clientWidth
      }
      // Default width size
      return 384 - 32
    },
    openSidebar (tabId) {
      this.activeTab = this.tabs.find(tab => tab.id === tabId)

      this.sidebarIsOpen = true
    },

    arrowBtnHandler () {
      if (this.sidebarIsOpen) {
        this.closeSidebar()
      } else {
        this.sidebarIsOpen = true
      }
    },

    closeSidebar () {
      KnowledgeBus.$emit('checked::clear')
      this.sidebarIsOpen = false
    }

  }
}
</script>

<style lang="scss" scoped>
    .sidebar {
        display: flex;
        position: absolute;
        top: 0;
        right: calc(-427px + 32px);
        height: 100%;
        max-width: 100%;
        overflow: hidden;
        z-index: 49;
        background-color: $or-white;
        box-shadow: 0 0 8px 1px rgba(0,0,0,0.08);

        &__toolbar {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            max-width: 32px;
            min-width: 32px;
            border-right: solid 1px $or-grey-medium;

            .material-icons {
                color: $or-grey-dark;

                &:hover {
                    color: darken($or-grey-dark, 10%);
                    cursor: pointer;
                    transition: all .2s ease;
                }
            }

            .arrow-btn-wrap {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 67px;
                margin: 0 6px;
                border-bottom: solid 1px $or-grey-medium;

                .material-icons {
                    margin-top: 24px;
                }
            }

            .icons-wrap {
                display: flex;
                flex-direction: column;
                margin-top: 8px;

                .icon-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 8px 0;

                    .material-icons {
                        font-size: 20px;

                        &.active {
                            color: $or-black-blue;
                        }
                    }

                }
            }
        }

        &__body {
            display: flex;
            flex-direction: column;
            width: calc(427px - 32px);

            .caption {
                font-size: 18px;
                font-weight: bold;
                color: $or-black-blue;
                margin: 16px 16px 0;
            }

            .wrap {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                overflow: hidden;

                .service-wrap {
                    height: 100%;
                }
            }
        }
    }
</style>
